import { Component } from '@angular/core';

@Component({
    selector: 'app-generate-formular-info',
    templateUrl: './generate-formular-info.component.html',
    styleUrl: './generate-formular-info.component.scss',
})
export class GenerateFormularInfoComponent {}
